<template>
  <div>
    <z-title class="confirmation-token__title" tag="h1" size="medium">
      Verifique seu {{ translatedChannelDestiny }}
    </z-title>
    <div class="confirmation-token__subtitle">
      <z-text size="medium" tag="div">
        Digite o código numérico de 6 dígitos que enviamos por {{ translatedChannel }} para:
      </z-text>
      <z-text tag="div" size="medium" weight="bold">
        {{ selectedChannel.value }}
      </z-text>
    </div>

    <form @submit.prevent="validateToken()">
      <z-input-field
        label="Código de confirmação"
        :has-error="confirmationTokenForm.fields.token.hasError"
        :error-message="confirmationTokenForm.fields.token.error"
      >
        <z-input
          v-model="confirmationTokenForm.fields.token.value"
          :has-error="confirmationTokenForm.fields.token.hasError"
          placeholder="Ex.: 654321"
          v-mask="'######'"
          alt="Código de confirmação"
        />
      </z-input-field>
      <z-button
        :is-loading="validatingToken"
        variant="primary"
        size="medium"
        behavior="block"
        type="submit"
        alt="Validar código"
        class="confirmation-token__validate"
      >
        Validar código
      </z-button>
    </form>
    <z-button
      :is-loading="generatingNewConfirmationToken"
      variant="secondary"
      size="medium"
      behavior="block"
      alt="Reenviar código"
      @click="generateConfirmationToken()"
      class="confirmation-token__generate-token"
      :is-disabled="!canGenerateNewConfirmationToken"
    >
      {{ generateNewConfirmationTokenText }}
    </z-button>
    <z-link
      color="primary"
      size="medium"
      alt="Voltar"
      @click="backToChannelSelection()"
      class="confirmation-token__back"
    >
      Voltar
    </z-link>
  </div>
</template>
<script>
import { FormGroup } from 'utils/form';
import CurrentStudentService from 'services/CurrentStudentService';

export default {
  data() {
    return {
      validatingToken: false,
      confirmationTokenForm: new FormGroup({
        cpfHash: {},
        type: {},
        channel: {},
        token: {
          value: '', required: true, minLength: 6, maxLength: 6,
        },
      }),
      generatingNewConfirmationToken: false,
      generateNewConfirmationTokenTimeout: 59,
      generateNewConfirmationTokenInterval: null,
    };
  },
  props: {
    selectedChannel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canGenerateNewConfirmationToken() {
      return this.generateNewConfirmationTokenTimeout === 0;
    },
    generateNewConfirmationTokenText() {
      if (this.canGenerateNewConfirmationToken) {
        return 'Reenviar código';
      }

      return this.generateNewConfirmationTokenTimeoutText;
    },
    generateNewConfirmationTokenTimeoutText() {
      if (this.generateNewConfirmationTokenTimeout < 10) {
        return `Reenviar código em 00:0${this.generateNewConfirmationTokenTimeout}`;
      }

      return `Reenviar código em 00:${this.generateNewConfirmationTokenTimeout}`;
    },
    translatedChannelDestiny() {
      if (this.selectedChannel.channel === 'email') {
        return 'e-mail';
      }

      return 'celular';
    },
    translatedChannel() {
      if (this.selectedChannel.channel === 'email') {
        return 'e-mail';
      }

      return 'SMS';
    },
  },
  activated() {
    this.confirmationTokenForm.addValues({
      cpfHash: this.$route.params.cpfHash,
      type: this.$route.meta.channelType,
      channel: this.selectedChannel.channel,
    });

    this.generateNewConfirmationTokenInterval = setInterval(() => {
      this.generateNewConfirmationTokenTimeout -= 1;

      if (this.generateNewConfirmationTokenTimeout === 0) {
        clearInterval(this.generateNewConfirmationTokenInterval);
      }
    }, 1000);
  },
  methods: {
    validateToken() {
      if (this.confirmationTokenForm.validateForm()) {
        this.validatingToken = true;

        CurrentStudentService.validateConfirmationToken(this.confirmationTokenForm.getRawValue())
          .then((response) => {
            this.$emit('reset-password-token-generated', response.reset_password_token);
          })
          .catch(() => {
            this.confirmationTokenForm.fields.token.error = 'Token inválido';
            this.confirmationTokenForm.fields.token.errors = ['Token inválido'];
          })
          .finally(() => {
            this.validatingToken = false;
          });
      }
    },
    generateConfirmationToken() {
      this.generatingNewConfirmationToken = true;

      CurrentStudentService.generateConfirmationToken(this.confirmationTokenForm.getRawValue())
        .then(() => {
          this.$toast.show('success', 'Novo código gerado com sucesso', 4000);
        })
        .catch(() => {
          this.$toast.show('danger', 'Falha ao gerar novo código, tente novamente mais tarde', 4000);
        })
        .finally(() => {
          this.generatingNewConfirmationToken = false;
        });
    },
    backToChannelSelection() {
      this.$emit('back-to-channel-selection');
    },
  },
};
</script>
<style lang="scss" scoped>
.confirmation-token__title {
  margin-bottom: var(--space-large);
}

.confirmation-token__subtitle {
  margin-bottom: var(--space-large);
}

.confirmation-token__validate {
  margin-bottom: var(--space-medium);
}

.confirmation-token__generate-token {
  margin-bottom: var(--space-medium);
}

.confirmation-token__back {
  display: block;
  margin: 0 auto;
  text-align: center;
}
</style>
